// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + "shipbob_pricing_ui_styles" + "." + "c6ef1b99" + ".chunk.css";
};